module.exports = __webpack_public_path__ + "static/media/india2x.c7adfa15.png";